export default class EventEmitter {
    public callbacks: {
        [key: string]: any;
    };

    public constructor() {
        this.callbacks = {};
        this.callbacks.base = {};
    }

    public on(_names: string, _callback: Function, _unsubscribe?: Function) {
        if (typeof _names === 'undefined' || _names === '') {
            console.warn('wrong names');
            return false;
        }
        if (typeof _callback === 'undefined') {
            console.warn('wrong callback');
            return false;
        }

        const names = EventEmitter.resolveNames(_names);

        names.forEach((_name) => {
            const name = EventEmitter.resolveName(_name);

            if (!(this.callbacks[name.namespace] instanceof Object)) {
                this.callbacks[name.namespace] = {};
            }

            if (!(this.callbacks[name.namespace][name.value] instanceof Array)) {
                this.callbacks[name.namespace][name.value] = [];
            }

            this.callbacks[name.namespace][name.value].push(_callback);
        });

        return { _names, _callback, _unsubscribe };
    }

    public trigger(_name: string, _args?: any[]) {
        if (typeof _name === 'undefined' || _name === '') {
            console.warn('wrong name');
            return false;
        }

        let finalResult: null | undefined = null;
        let result = null;

        const args = !(_args instanceof Array) ? [] : _args;

        const names = EventEmitter.resolveNames(_name);
        const name = EventEmitter.resolveName(names[0]);
        const { namespace, value } = name;

        if (namespace === 'base') {
            const callbacks = this.callbacks[namespace];
            const callback = this.callbacks[namespace][value];

            if (callbacks instanceof Object && callback instanceof Array) {
                callback.forEach((callback) => {
                    result = callback.apply(this, args);

                    if (typeof finalResult === 'undefined') {
                        finalResult = result;
                    }
                });
            }
        } else if (this.callbacks[namespace] instanceof Object) {
            if (value === '') {
                console.warn('wrong name');
                return this;
            }

            this.callbacks[namespace][value].forEach((callback: Function) => {
                result = callback.apply(this, args);

                if (typeof finalResult === 'undefined') {
                    finalResult = result;
                }
            });
        }

        return finalResult;
    }

    public remove(_target: {
        _names: string;
        _callback: Function;
        _unsubscribe?: Function;
    }) {
        const { _names, _callback, _unsubscribe } = _target;

        if (typeof _names === 'undefined' || _names === '') {
            console.warn('wrong names');
            return false;
        }
        if (typeof _callback === 'undefined') {
            console.warn('wrong callback');
            return false;
        }

        const names = EventEmitter.resolveNames(_names);

        names.forEach((_name) => {
            const name = EventEmitter.resolveName(_name);
            const { namespace, value } = name;

            if (!(this.callbacks[namespace] instanceof Object)) return;
            if (!(this.callbacks[namespace][value] instanceof Array)) return;

            this.callbacks[namespace][value] = this.callbacks[namespace][value].filter(
                (callback: Function) => callback !== _callback
            );

            if (_unsubscribe instanceof Function) _unsubscribe();

            if (!this.callbacks[namespace][value].length) {
                delete this.callbacks[namespace][value];
            }
        });

        return this;
    }

    // ✅ DODAJ: Prostsza wersja off (bez obiektu)
    public off(_names: string, _callback: Function) {
        return this.remove({ _names, _callback });
    }

    // ✅ DODAJ: Usuń wszystkie listenery dla eventu lub wszystkie
    public removeAllListeners(_names?: string) {
        if (!_names) {
            // Usuń wszystkie listenery
            this.callbacks = {};
            this.callbacks.base = {};
            return this;
        }

        const names = EventEmitter.resolveNames(_names);

        names.forEach((_name) => {
            const name = EventEmitter.resolveName(_name);
            const { namespace, value } = name;

            if (this.callbacks[namespace] instanceof Object) {
                if (value && this.callbacks[namespace][value]) {
                    delete this.callbacks[namespace][value];
                } else {
                    // Usuń cały namespace
                    delete this.callbacks[namespace];
                }
            }
        });

        return this;
    }

    // ✅ DODAJ: Sprawdź liczbę listenerów
    public listenerCount(_name: string): number {
        const names = EventEmitter.resolveNames(_name);
        const name = EventEmitter.resolveName(names[0]);
        const { namespace, value } = name;

        if (this.callbacks[namespace]?.[value] instanceof Array) {
            return this.callbacks[namespace][value].length;
        }

        return 0;
    }

    public static resolveNames(_names: string) {
        let names = _names;
        let names_step_1 = names.replace(/[^a-zA-Z0-9 ,/.]/g, '');
        let names_step_2 = names_step_1.replace(/[,/]+/g, ' ');
        let names_step_3 = names_step_2.split(' ');

        return names_step_3;
    }

    public static resolveName(name: string): {
        original: string;
        value: string;
        namespace: string;
    } {
        const newName: any = {};
        const [value, namespace] = name.split('.');

        newName.original = name;
        newName.value = value;
        newName.namespace = 'base';

        if (namespace) {
            newName.namespace = namespace;
        }

        return newName;
    }
}